// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falCirclePlus: CreateIconOptions = {
  "displayName": "FALCirclePlus",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z"
};
